function bar(x) {
  return `bar${x}`;
}

module.exports = bar;
